require('./vmsBackupActions.style.scss');

const Task = require('../../../../model/Task');

class VmsBackupActionsController {
    constructor($rootScope, $scope, crudService, sharedPersistenceService) {
        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.crudService = crudService;
        this.sharedPersistence = sharedPersistenceService;
        this.TASKS_REST = this.sharedPersistence.getRestEndpoints().TASKS_REST;

        this.$rootScope.$on('task.refresh', (event, data) => {
            const taskData = Task.fromRaw(data);
            if (taskData.uuid !== this.taskId) return;
            this.progress = taskData.progress;

            if (
                this.progress === 100 &&
                taskData.vmName === this.virtualMachinesController.selectedVirtualMachine.name
            ) {
                this.getBackups(taskData);
            }
        });
    }

    $onInit() {
        this.getTask();
    }

    getTask() {
        if (this.selectedBackup.lastRestoreStatus === 'RUNNING') {
            this.taskId = this.selectedBackup.lastRestoreTaskUuid;
        } else {
            this.taskId = this.selectedBackup.taskId;
        }
        this.crudService.get(this.TASKS_REST + '/' + this.taskId).then((res) => {
            const taskDetails = res.data.entities[0];
            this.progress = taskDetails.progress;
        });
    }

    getBackups(taskData) {
        this.virtualMachinesController.persistence
            .getRestoredVirtualMachineDetails(taskData.virtualMachineUuid)
            .then((virtualMachine) => {
                this.virtualMachinesController.virtualMachines = this.virtualMachinesController.virtualMachines.map(
                    (vm) => {
                        if (vm.name === virtualMachine.name) {
                            vm.uuid = virtualMachine.uuid;
                        }
                        return vm;
                    }
                );
                this.virtualMachinesController.setVirtualMachineDetails(virtualMachine);
                if (taskData.vmName === this.virtualMachinesController.selectedVirtualMachine.name) {
                    this.virtualMachinesController.persistence
                        .showBackups(
                            {
                                id: virtualMachine.uuid,
                                name: this.selectedBackup.vmName,
                            },
                            this.virtualMachinesController.dateFilter,
                            true
                        )
                        .then((restorePoints) => {
                            this.virtualMachinesController.restorePoints = restorePoints;
                            if (
                                this.virtualMachinesController.selectedRestorePoint &&
                                this.virtualMachinesController.selectedRestorePoint[0]
                            ) {
                                let selectedItem = restorePoints.filter(
                                    (item) => item.uuid == this.virtualMachinesController.selectedRestorePoint[0].uuid
                                )[0];
                                if (selectedItem) {
                                    this.virtualMachinesController.selectedRestorePoint[0] = selectedItem;
                                }
                            }
                        });
                }
            });
    }

    goToInProgressJob() {
        if (this.selectedBackup && this.taskId && this.goToJob) {
            this.goToJob({ jobUuid: this.taskId });
        }
    }
}

const vmsBackupActionsComponent = {
    controller: VmsBackupActionsController,
    require: {
        virtualMachinesController: '^^virtualMachines',
    },
    template: require('./vmsBackupActions.template.html'),
    bindings: {
        selectedBackup: '=',
        backupAction: '<?',
        ctxGridTopOffset: '<?',
        goToJob: '&?',
    },
};

VmsBackupActionsController.$inject = ['$rootScope', '$scope', 'crudService', 'sharedPersistenceService'];

module.exports = vmsBackupActionsComponent;



// WEBPACK FOOTER //
// ./src/azurebackup/views/virtualMachines/vmsBackups/vmsBackupActions/vmsBackupActions.component.js